namespace TabAurous.OMS {
    export namespace CashFlowService {
        export const baseUrl = 'OMS/CashFlow';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<AccountGroupRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "OMS/CashFlow/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>CashFlowService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
